import { useAuth } from '../../utils/Auth/AuthProvider';
import TeacherDashboard from '../../school_panel/pages/dashboards/TeacherDashboard';
import SchoolAdminDashboard from '../../school_panel/pages/dashboards/SchoolAdminDashboard';
import CounselorDashboard from '../../school_panel/pages/dashboards/CounselorDashboard';

export default function SchoolDashboard() {
  const { role } = useAuth();
  if (role === 'teacher') return <TeacherDashboard />;
  if (role === 'counselor') return <CounselorDashboard />;
  return <SchoolAdminDashboard />;
}
